module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp1_6.8802cea4.png";